module.exports = __webpack_public_path__ + "static/media/agent_kyc.6e26b534.svg";